<template>
    <div class="item-wrap">
        <p
            class="label"
            @click="onEdit"
        >
            {{entityLabel}}
        </p>
        <div class="tool-wrap">
            <or-icon-button
                icon="delete"
                size="small"
                type="secondary"
                class="flat"
                disable-ripple
                @click="onDelete"
            />
        </div>
        <or-confirm
            ref="delete-flow-entity-confirm"
            :title="$t('model.nlu-model.sidebar.flow_entities.flow_entity_item.modal.title')"
            type="danger"
            confirm-button-text="Delete"
            :close-on-confirm="false"
            :loading="isLoading"
            @confirm="onDeleteConfirm"
        >
          {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_item.modal.description') }}
        </or-confirm>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    flowEntity: Object
  },

  computed: {
    entityLabel () {
      return this.flowEntity.name
    }
  },

  data () {
    return {
      isLoading: false
    }
  },

  methods: {
    ...mapActions('knowledgebase/entities', ['deleteEntity']),

    onEdit () {
      this.$emit('edit', this.flowEntity)
    },

    onDelete () {
      this.$refs['delete-flow-entity-confirm'].open()
    },

    async onDeleteConfirm () {
      this.isLoading = true
      await this.deleteEntity({ item: { ...this.flowEntity, type: 'postprocess' } })
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
    .item-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 $sp-1 0 $sp-3;

        &:hover {
            cursor: pointer;
            background-color: $or-grey-light;
        }

        .label {
            display: flex;
            flex-grow: 1;
            margin: 0;
            font-size: 14px;
            color: $or-black-blue;
        }
    }
</style>
